import { use, useEffect, useState } from 'react'

import { GetDynamicData as BLGetDynamicData } from './../../../utilities/BL/Admin/Dashboard/Dynamics'
import { SendNextCard as BLSendNextCard, ResetCurrentDynamic as BLResetCurrentDynamic, SendResultsToScreen, StartLottery, GetAllLotteryResults, GetAllLotteryResultsByCard } from './../../../utilities/BL/Zones'

import { SecondaryBase } from './../Commons/SecondaryBase'
import { GeneralResultsChart } from './ResultsCharts/GeneralResultsChart'
import { BarResultsByItem } from './ResultsCharts/BarResultsByItem'


const Lottery = ({ getOutOfTheDynamic }) => {
    const [lottery,setLottery] = useState([])
    const [currentIndex,setCurrentIndex] = useState(0)
    const [gameStarted,setGameStarted] = useState(false)
    
    const [showResults,setShowResults] = useState(false)
    const [results,setResults] = useState(null)
    const [lotteryResults,setLotteryResults] = useState(null)

    const [errorMessage,setErrorMessage] = useState(null)

    const [selectedView,setSelectedView] = useState(null)
    const [selectedBoardSize,setSelectedBoardSize] = useState(null)
    
    const [viewError,setViewError] = useState(false)
    const [boardSizeError,setBoardSizeError] = useState(false)
    const [startGameError,setStartGameError] = useState(null)


    const viewsData = [
        {
            "src": "/img/games/lottery/view-1.png",
            "text": "Vista #1",
            "value": 1
        },
        {
            "src": "/img/games/lottery/view-2.png",
            "text": "Vista #2",
            "value": 2
        },
        {
            "src": "/img/games/lottery/view-3.png",
            "text": "Vista #3",
            "value": 3
        },
        {
            "src": "/img/games/lottery/view-4.png",
            "text": "Vista #4",
            "value": 4
        },
        {
            "src": "/img/games/lottery/view-5.png",
            "text": "Vista #5",
            "value": 5
        },
        {
            "src": "/img/games/lottery/view-6.png",
            "text": "Vista #6",
            "value": 6
        },
        {
            "src": "/img/games/lottery/view-7.png",
            "text": "Vista #7",
            "value": 7
        }
    ]

    const boardSizeData = [
        {
            "text": "Selecciona el tamaño",
            "value": 0
        },
        {
            "text": "2 x 2",
            "value": 2
        },
        {
            "text": "3 x 3",
            "value": 3
        }
    ]

    //----- APIS -----//

    const ShowResultsView = async () => {
        try {
            debugger
            setErrorMessage(null)

            // 1. Obtener resultados generales
            debugger
            const generalResponse = await GetAllLotteryResults()
            debugger
            if (!generalResponse.success || !Array.isArray(generalResponse.data)) {
                setErrorMessage('No fue posible obtener los resultados generales de la lotería.')
                console.warn("⚠️ Error en GetAllLotteryResults:", generalResponse.message)
                return
            }

            // 2. Obtener resultados por carta
            debugger
            const byCardResponse = await GetAllLotteryResultsByCard()
            debugger
            if (!byCardResponse.success || !Array.isArray(byCardResponse.data)) {
                setErrorMessage('No fue posible obtener los resultados por carta.')
                console.warn("⚠️ Error en GetAllLotteryResultsByCard:", byCardResponse.message)
                return
            }

            debugger
            // 3. Plantilla base de zonas
            const zonesTemplate = [
                { name: "Zona Laboratorio Tequis", text: "Laboratorio Tequis", points: 0, show: false },
                { name: "Zona Canels", text: "Canels", points: 0, show: false },
                { name: "Zona Seguros El Potosí", text: "Seguros El Potosí", points: 0, show: false },
                { name: "Zona Red Cola", text: "Red Cola", points: 0, show: false },
                { name: "Zona Tecate", text: "Tecate", points: 0, show: false },
                { name: "Zona Moctezuma", text: "Moctezuma", points: 0, show: false },
                { name: "Zona Nissan", text: "Nissan", points: 0, show: false },
                { name: "Zona Mobil", text: "Mobil", points: 0, show: false },
                { name: "Zona Lounge Ron Potosí", text: "Lounge Ron Potosí", points: 0, show: false },
                { name: "Zona Azul", text: "Azul", points: 0, show: false },
                { name: "Zona Oro", text: "Oro", points: 0, show: false }
            ]

            // 4. Construir resultados generales
            debugger
            const totalPointsByZone = {}
            zonesTemplate.forEach(zone => totalPointsByZone[zone.text.toLowerCase()] = 0)

            debugger
            generalResponse.data.forEach(result => {
                const key = result.zona.toLowerCase().trim()
                const pts = result.puntos || 0

                if (totalPointsByZone.hasOwnProperty(key)) {
                    totalPointsByZone[key] += pts
                } else {
                    totalPointsByZone[key] = pts
                }
            })

            debugger
            const finalResultsPerZone = zonesTemplate.map(zone => {
                const key = zone.text.toLowerCase()
                const points = totalPointsByZone[key] || 0

                return {
                    ...zone,
                    key,
                    points,
                    show: points > 0
                }
            })

            // 5. Construir resultados por carta
            debugger
            const breakdownByCard = byCardResponse.data.map(card => {
                const pointsByZone = {}
                ;(card.zonas || []).forEach(z => {
                    const key = z.zona.toLowerCase().trim()
                    const puntos = z.puntos || 0
                    pointsByZone[key] = puntos
                })

                return {
                    itemId: card.idCard,
                    pointsByZone
                }
            })

            // 6. Guardar estado
            debugger
            setResults(finalResultsPerZone)
            setLotteryResults(breakdownByCard)
            setShowResults(true)

            // 7. Enviar resultados a la pantalla
            debugger
            const responseShowResults = await SendResultsToScreen()
            if (responseShowResults.success) {
                console.log("Info enviada a la pantalla correctamente")
            } else {
                console.warn(responseShowResults.message)
            }
        } catch (error) {
            console.error("❌ Error al mostrar resultados:", error)
            setErrorMessage("Ocurrió un error al intentar mostrar los resultados. Intenta nuevamente.")
        }
    }

    const StartGame = async () => {
        try {
            setViewError(false)
            setBoardSizeError(false)
            setStartGameError(null)
            
            if (selectedView && selectedBoardSize) {
                // Tomar la primera carta
                setCurrentIndex(0)
                
                const response = await StartLottery(selectedBoardSize, selectedView)

                if (response.success) {
                    setGameStarted(true)
                    console.log('Juego iniciado')
                    
                    const responseCard = await SendNextCard(lottery[0])
                    
                    if (!responseCard.success) {
                        console.log(responseCard.message)
                    }
                } else {
                    setGameStarted(false)
                    console.log(response.message)
                }
            } else {    
                if (!selectedView && !selectedBoardSize) {
                    setViewError(true)
                    setBoardSizeError(true)

                    setStartGameError("No ha sido posible iniciar el juego. Inténtalo nuevamente o inténtalo más tarde.")
                    console.log("No ha sido posible iniciar el juego. Inténtalo nuevamente o inténtalo más tarde.")
                } else if (!selectedView) {
                    setViewError(true)

                } else if (!selectedBoardSize) {
                    setBoardSizeError(true)
                }
            }
        } catch (error) {
            
        }
    }

    const SendNextCard = async (card) => {
        try {
            const response = await BLSendNextCard(card.id, selectedView)
            if (response.success) {
                console.log('Carta enviada a los aficionados y pantalla')
                return { success: true, data: null }
            } else {
                console.log(response.message)
                return { success: false, message: '' }
            }
        } catch (error) {
            
        }
    }

    const GetLotteryData = async () => {
        try {
            const response = await BLGetDynamicData()
            if (response.success) {
                setLottery(response.data)
                setCurrentIndex(0)
            } else {
                console.log(response.message)
            }
        } catch (error) {
            
        }
    }

    //----- APIS -----//

    const ReturnToDashboard = async () => {
        try {
            await BLResetCurrentDynamic()
            getOutOfTheDynamic()
        } catch (error) {
            
        }
    }

    const SaveView = async (idView) => {
        try {
            setViewError(false)

            const view = Number(idView)
            
            if (!view || isNaN(view)) {
                setViewError(true)
                return
            }

            if (view > 0 && view < 9) {
                setSelectedView(idView)
            } else {
                setViewError(true)
                return
            }
        } catch (error) {
            
        }
    }

    const SaveBoardSize = async (idBoardSize) => {
        try {
            setBoardSizeError(false)

            const boardSize = Number(idBoardSize)

            if (!boardSize || isNaN(boardSize)) {
                setBoardSizeError(true)
                return
            }

            if (boardSize === 2 || boardSize === 3) {
                setSelectedBoardSize(boardSize)
            } else {
                setBoardSizeError(true)
            }
        } catch (error) {
            console.error("❌ Error al guardar tamaño de tabla:", error)
        }
    }

    const handleNext = async () => {
        if (currentIndex < lottery.length - 1) {
            const nextIndex = currentIndex + 1
            const nextCard = lottery[nextIndex]

            setCurrentIndex(nextIndex)

            if (gameStarted) {
                const response = await SendNextCard(nextCard)
                if (!response.success) {
                    console.warn('❌ No se pudo enviar la siguiente carta')
                }
            }
        }
    }

    const handlePrev = async () => {
        if (currentIndex > 0) {
            const prevIndex = currentIndex - 1
            const prevCard = lottery[prevIndex]

            setCurrentIndex(prevIndex)

            if (gameStarted) {
                const response = await SendNextCard(prevCard)
                if (!response.success) {
                    console.warn('❌ No se pudo enviar la carta anterior')
                }
            }
        }
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
            
            await GetLotteryData()
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])

 
    if (!lottery.length) return <p>Cargando...</p>

    const currentCard = lottery[currentIndex]


    return (
        <SecondaryBase actionToExecute={ReturnToDashboard}>
            {showResults ? (
                <>
                    <p className="mb-3 fw-bold text-center">Resultados generales</p>

                    <GeneralResultsChart data={results.filter(r => r.show)} />

                    {results.map((result, index) => (
                        result.show && (
                            <p key={index}>{result.text}: {result.points}</p>
                        )
                    ))}

                    <p className="mt-5 pt-5 mb-3 fw-bold text-center">Resultados por carta</p>
                    {lotteryResults.map((lotteryResult, idx) => (
                        <BarResultsByItem
                            key={idx}
                            questionId={lotteryResult.questionId}
                            pointsByZone={lotteryResult.pointsByZone}
                            results={results}
                            title={'Carta: '}
                        />
                    ))}
                </>
            ) : (
                <>
                    <section className='AdmLottery'>
                        {gameStarted === true ? (
                            <p className='AdmLottery__Title'>Mostrando actualmente:</p>
                        ) : (
                            <p className='AdmLottery__Title'>Cartas que se le mostrarán al aficionado al iniciar:</p>
                        )}

                        <div className='AdmLottery__Quiz'>
                            {/* Flecha izquierda para escritorio */}
                            <div className='AdmLottery__Quiz__LeftSection'>
                                {gameStarted === false && currentIndex > 0 && (
                                    <button type='button' onClick={() => handlePrev(currentCard)} className='Btn__Adsl--RedOutlineTransparent AdmLottery__Quiz__LeftSection__Button'>
                                        <i className="bi bi-caret-left-fill"></i> Anterior
                                    </button>
                                )}
                            </div>

                            {/* Carta y texto */}
                            <div className="AdmLottery__Quiz__Questions text-center">
                                {lottery && (
                                    lottery.length > 0 && (
                                        <p className="AdmLottery__Quiz__Questions__Counter">Carta {currentIndex + 1} de {lottery.length}</p>
                                    )
                                )}

                                <img className='AdmLottery__Quiz__Questions__Card' src={currentCard.imgPath} />
                                
                                <p className="AdmLottery__Quiz__Questions__Question">{currentCard.text}</p>
                            </div>

                            {/* Flecha derecha para escritorio */}
                            <div className='AdmLottery__Quiz__RightSection'>
                                {currentIndex < lottery.length - 1 && (
                                    <button type='button' onClick={() => handleNext(currentCard)} className='Btn__Adsl--RedOutlineTransparent AdmLottery__Quiz__RightSection__Button'>
                                        Siguiente <i className="bi bi-caret-right-fill"></i>
                                    </button>
                                )}
                            </div>

                            {/* Flechas para celular */}
                            <div className='AdmLottery__Quiz__BottomSection'>
                                {gameStarted === false && currentIndex > 0 && (
                                    <button type='button' onClick={() => handlePrev(currentCard)} className='Btn__Adsl--RedOutlineTransparent AdmLottery__Quiz__BottomSection__Button'>
                                        <i className="bi bi-caret-left-fill"></i>
                                    </button>
                                )}
                                {currentIndex < lottery.length - 1 && (
                                    <button type='button' onClick={() => handleNext(currentCard)} className='Btn__Adsl--RedOutlineTransparent AdmLottery__Quiz__BottomSection__Button'>
                                        <i className="bi bi-caret-right-fill"></i>
                                    </button>
                                )}
                            </div>
                        </div>
                    </section>

                    <section className='AdmLottery__ActionButtons'>
                        <p className='AdmLottery__ActionButtons__Title text-center'>Controles del administrador</p>
                        
                        {gameStarted === true && (
                            <p className='text-success text-center'><i className="bi bi-play-circle"></i> Juego en proceso</p>
                        )}

                        <div className='AdmLottery__ActionButtons__Container'>
                            {gameStarted === false && (
                                <>
                                    <label className={`AdmLottery__ActionButtons__Container__Label ${viewError === true && 'AdmLottery__ActionButtons__Container__Label--Error'}`}>Elige la vista de la lotería</label>
                                    <div className='AdmLottery__ActionButtons__Container__ImageList'>
                                        {viewsData.map((view,index) => (
                                            <button key={index} type='button' className={`AdmLottery__ActionButtons__Container__ImageList__Button ${selectedView === view.value && 'AdmLottery__ActionButtons__Container__ImageList__Button--Active'}`} onClick={() => SaveView(view.value)}>
                                                <img src={view.src} className='AdmLottery__ActionButtons__Container__ImageList__Button__Image' />
                                                <span>{view.text}</span>
                                            </button>
                                        ))}
                                    </div>

                                    <label className={`AdmLottery__ActionButtons__Container__Label ${boardSizeError === true && 'AdmLottery__ActionButtons__Container__Label--Error'}`}>Selecciona el tamaño de las tablas</label>
                                    <select className='AdmLottery__ActionButtons__Container__List' onChange={(e) => SaveBoardSize(e.target.value)}>
                                        {boardSizeData.map((size,index) => (
                                            <option key={index} value={size.value}>{size.text}</option>
                                        ))}
                                    </select>

                                    <label className={'AdmLottery__ActionButtons__Container__Label mt-4'}>Vista seleccionada: {selectedView && `Vista #${selectedView}`}</label>
                                    <label className={'AdmLottery__ActionButtons__Container__Label'}>Tamaño seleccionado: {selectedBoardSize && `${selectedBoardSize} x ${selectedBoardSize}`}</label>

                                    <button type='button' className='Btn__Adsl--RedOutlineTransparent ms-auto me-auto mt-3' onClick={() => StartGame(currentCard)}><i className="bi bi-play-circle"></i> Iniciar juego</button>
                                    {startGameError && startGameError !== '' && ( <p className='text-danger mb-0 text-center small'>{startGameError}</p> )}
                                </>
                            )}
                            {gameStarted === true && (
                                <>
                                    <p>Vista seleccionada: {selectedView && `Vista #${selectedView}`}</p>
                                    <p>Tamaño seleccionado: {selectedBoardSize && `${selectedBoardSize} x ${selectedBoardSize}`}</p>

                                    <button type='button' className='Btn__Adsl--RedOutlineTransparent ms-auto me-auto' onClick={() => ShowResultsView()}><i className="bi bi-bar-chart"></i> Mostrar resultados en pantalla</button>
                                    {errorMessage && errorMessage !== '' && ( <p className='text-danger mb-0 text-center small'>{errorMessage}</p> )}
                                </>
                            )}
                        </div>
                    </section>
                </>
            )}
        </SecondaryBase>
    )
}

export { Lottery };